interface NearestPickerIndexParams {
  scrollTop: number;
  itemHeight: number;
  maxIndex: number;
}

export const getNearestPickerIndex = ({
  scrollTop,
  itemHeight,
  maxIndex,
}: NearestPickerIndexParams): number => {
  if (!Number.isFinite(scrollTop) || !Number.isFinite(itemHeight) || itemHeight <= 0) {
    return 0;
  }

  if (maxIndex <= 0) {
    return 0;
  }

  const index = Math.round(scrollTop / itemHeight);
  return Math.min(Math.max(index, 0), maxIndex);
};
